module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAFCAYAAACJmvbYAAAAAXNSR0IArs4c6QAAAGJJREFUCB1jYIACExMTdWNjYzcYH0QzgQgzMzO1////Hwcyd5qammaBxECA2cbGRvD379/7gGwZsAgDg7u0tPTxZ8+e3WMEGrUEKBgNlYBR7zk4OORBxn6CiSDRb1lZWf8DAKc6FyM8R86SAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/arrow.png
// module id = vQMo
// module chunks = 0